






















































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import {
  GetStudentsList$,
  GetAllBanjis$,
  DeleteStudents$,
} from "@/request/jxgl";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../components/left-nav.vue";
import StudentTable from "./student-list.vue";
import AddBanjiDialog from "./add-banji-dialog.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    StudentTable,
    Pagination,
    AddBanjiDialog,
  },
})
export default class BjglList extends Vue {
  private filters: any = {
    class_id: "",
    姓名: "",
    current_page: 1,
    total_count: 0,
    page_count: 10,
  };
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 列表
  private students: any[] = [];
  // 添加班级
  private banjis: any[] = [];
  private ifShowAddBanji: boolean = false;
  private setFilters() {
    localStorage.setItem("bjglListFilters", JSON.stringify(this.filters));
  }
  // 获得全部班级
  private fetchAllBanji() {
    GetAllBanjis$(this).then((data) => {
      // console.log(data);
      this.banjis = data;
    });
  }
  // 选中改变
  private selectChange(value, item) {
    if (item.selected) {
      this.selectedMessages.push(item);
      this.selectedMessages = _.uniqBy(this.selectedMessages, "user_id");
    } else {
      const index = _.findIndex(this.selectedMessages, "user_id");
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 跳转添加学生
   */
  private jumpDetail() {
    this.$router.push("/main/jxgl/xs-detail");
  }
  /**
   * @description 打开添加班级
   */
  private openAddBanji() {
    this.ifShowAddBanji = true;
  }
  /**
   * @description 获得学生列表
   */
  private fetchStudentList() {
    const params = _.cloneDeep(this.filters);
    GetStudentsList$(this, params).then((data: any) => {
      // console.log(data);
      data.students.forEach((student: any) => {
        const inc = _.findIndex(this.selectedMessages, (i) => {
          return i["user_id"] === student["user_id"];
        });
        if (inc !== -1) {
          student["selected"] = true;
        } else {
          student["selected"] = false;
        }
      });
      this.$set(this, "students", data.students);
      this.filters.total_count = data.total_count;
      this.setFilters();
    });
  }
  /**
   * @description 改变排序顺序
   */
  private changeOrderValue() {
    this.filters.order_value = this.filters.order_value === 0 ? 1 : 0;
    this.search();
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.current_page = 1;
    this.fetchStudentList();
  }
  /**
   * @description 全选
   */
  private selectAll() {
    this.students.forEach((student: any) => {
      student["selected"] = true;
      this.selectedMessages.push(student);
    });
    this.selectedMessages = _.uniqBy(this.selectedMessages, "user_id");
  }
  /**
   * @description 批量删除
   */
  private deleteThese() {
    this.$confirm("删除后将无法找回，您确定要删除么？", {
      title: "温馨提示",
    })
      .then((value) => {
        const arr: any[] = [];
        this.selectedMessages.forEach((item: any) => {
          arr.push(item.user_id);
        });
        const params: any = {
          data: {
            user_ids: arr,
          },
        };
        DeleteStudents$(this, params).then((data: any) => {
          this.$message.success("删除成功");
          this.selectedMessages = [];
          this.search();
        });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.current_page = val;
    this.fetchStudentList();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    const localFilters = localStorage.getItem("bjglListFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        class_id: "",
        姓名: "",
        current_page: 1,
        total_count: 0,
        page_count: 10,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    this.fetchAllBanji();
    this.fetchStudentList();
  }
}
